/* import __COLOCATED_TEMPLATE__ from './card-reorder-success.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();